import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Grid2,
  useTheme,
} from "@mui/material";
import { ColorOption, COLORS } from "../theme/colors";

interface ColorPickerDialogProps {
  open: boolean;
  onClose: () => void;
  onSelect: (color: ColorOption) => void;
  initialColor: string;
}

const ColorPickerDialog: React.FC<ColorPickerDialogProps> = ({
  open,
  onClose,
  onSelect,
  initialColor,
}) => {
  const theme = useTheme();

  const [selectedColor, setSelectedColor] = useState<ColorOption | null>(
    COLORS.find((color) => color.hex === initialColor) || null
  );

  useEffect(() => {
    const colorOption = COLORS.find(
      (color) => color.hex.toUpperCase() === initialColor.trim().toUpperCase()
    );
    setSelectedColor(colorOption || null);
  }, [initialColor]);

  const handleOk = () => {
    if (selectedColor) {
      onSelect(selectedColor);
    }
    onClose();
  };

  const handleColorClick = (color: ColorOption) => {
    setSelectedColor(color);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <Box sx={{ backgroundColor: theme.palette.custom.sForm }}>
        <DialogTitle>レポートで表示する色を選択してください</DialogTitle>
        <DialogContent>
          <Grid2 container spacing={1}>
            {COLORS.map((color) => (
              <Grid2 key={color.hex}>
                <Box
                  onClick={() => handleColorClick(color)}
                  sx={{
                    width: "40px",
                    height: "40px",
                    backgroundColor: color.hex,
                    border:
                      selectedColor?.hex === color.hex
                        ? "3px solid #000"
                        : "1px solid #ccc",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                  aria-label={color.name}
                />
              </Grid2>
            ))}
          </Grid2>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 0.5,
          }}
        >
          <Button
            onClick={onClose}
            variant="outlined"
            color="secondary"
            sx={{ width: "30%" }}
          >
            キャンセル
          </Button>
          <Button
            onClick={handleOk}
            variant="contained"
            color="primary"
            sx={{ width: "30%" }}
          >
            OK
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default ColorPickerDialog;
